module.exports = __webpack_public_path__ + "morele.png?fa241562c84669a594e306da2315198c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/morele.png
// module id = 982
// module chunks = 2